import { render, staticRenderFns } from "./_CollectedSelectedDialog.vue?vue&type=template&id=a1b49d06&scoped=true&"
import script from "./_CollectedSelectedDialog.vue?vue&type=script&lang=js&"
export * from "./_CollectedSelectedDialog.vue?vue&type=script&lang=js&"
import style0 from "./_CollectedSelectedDialog.vue?vue&type=style&index=0&id=a1b49d06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b49d06",
  null
  
)

export default component.exports